export default __webpack_public_path__ + "static/media/group-2186-1.cf5a820d.png";